/* src/announcement/cards/AnnouncementCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import _ from 'lodash';
import { loadTexts } from '../../../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { Send, Alarm } from '@material-ui/icons';

import styles from './styles';

import { sendAnnouncement, fetchAnnouncements } from '../../actions';
const TEXT_KEY = "announcements";

const users = ['tutors', 'students'];

class AnnouncementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ..._.zipObject(props.organizations.map(o => o.name), props.organizations.map(() => false)),
      ..._.zipObject(props.universities.map(u => u.name), props.universities.map(() => false)),
      ..._.zipObject(users, users.map(() => false)),
      delivery: 'now',
      value: 'all',
      texts: loadTexts(TEXT_KEY, props.locale),
      titleEn: '',
      titleFr: '',
      bodyEn: '',
      bodyFr: '',

      dontTranslate: false,
    };
  }

  _onChangeCheck = field => event => this.setState({ [field]: event.target.checked });
  _onChangeText = field => event => this.setState({ [field]: event.target.value });
  _onClickSend = async () => {
    const { tutors, students, titleEn, titleFr, bodyEn, bodyFr, dontTranslate } = this.state;
    const { organizations, universities } = this.props;

    const params = {
      organizations: [],
      universities: [],
      tutors,
      students,
      notification: {
        en: { title: titleEn, body: bodyEn },
        fr: {
          title: dontTranslate ? titleEn : titleFr,
          body: dontTranslate ? bodyEn : bodyFr,
        },
      },
    };

    if (tutors) {
      organizations.forEach(org => {
        if (this.state[org.name])
          params.organizations.push(org._id);
      });
    }

    universities.forEach(uni => {
      if (this.state[uni.name])
        params.universities.push(uni._id);
    });

    await this.props.sendAnnouncement(params);
    this.props.fetchAnnouncements();
  };

  _handleDelivery = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  _onClickDontTranslate = () => {
    this.setState(prev => ({ dontTranslate: !prev.dontTranslate }));
  };

  renderTitle(classes) {
    const { titleEn, titleFr, dontTranslate, texts } = this.state;
    const { input: { placeholder } } = texts;
    const { button_text } = texts;

    const input = (
      <Input
        placeholder={dontTranslate ? placeholder.set_title : placeholder.english}
        className={classes.message}
        fullWidth
        value={titleEn}
        onChange={this._onChangeText('titleEn')}
      />
    );

    return (
      <div className={classes.messageContainer}>
        <div className={classes.titleContainer}>
          <Typography variant="subheading">{texts.header.title}</Typography>
          <Button variant="contained" size="small" onClick={this._onClickDontTranslate}>
            {dontTranslate ? button_text.translate : button_text.no_translate}
          </Button>
        </div>
        {input}
        {!dontTranslate && (
          <Input
            placeholder={texts.input.placeholder.french}
            className={classes.message}
            fullWidth
            value={titleFr}
            onChange={this._onChangeText('titleFr')}
          />
        )}
      </div>
    );
  }

  renderMessage(classes) {
    const { bodyEn, bodyFr, dontTranslate, texts } = this.state;
    const { input: { placeholder } } = texts;
    const input = (
      <Input
        placeholder={dontTranslate ? placeholder.set_message : placeholder.english}
        className={classes.message}
        fullWidth
        value={bodyEn}
        onChange={this._onChangeText('bodyEn')}
      />
    );

    return (
      <div className={classes.messageContainer}>
        <Typography variant="subheading">{texts.header.message}</Typography>
        {input}
        {!dontTranslate && (
          <Input
            placeholder={placeholder.french}
            className={classes.message}
            fullWidth
            value={bodyFr}
            onChange={this._onChangeText('bodyFr')}
          />
        )}
      </div>
    );
  }

  renderTarget(classes, value) {
    const { texts } = this.state;
    return (
      <div className={classes.messageContainer}>
        <Typography variant="subheading">
          {texts.header.target_user}
        </Typography>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup row>
            {users.map(u => (
              <FormControlLabel
                key={u}
                label={_.upperFirst(u)}
                control={
                  <Checkbox
                    checked={this.state[u]}
                    onChange={this._onChangeCheck(u)}
                    value={u}
                    color="primary"
                  />
                }
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>
    );
  }

  renderOrganizations(classes) {
    const { texts } = this.state;
    return (
      <Collapse in={this.state.tutors} timeout="auto" unmountOnExit>
        <div>
          <div className={classes.messageContainer}>
            <Typography variant="subheading">
              {texts.header.target_org}
            </Typography>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup row>
                {this.props.organizations.map(o => (
                  <FormControlLabel
                    key={o._id}
                    label={o.name}
                    control={
                      <Checkbox
                        checked={this.state[o.name]}
                        onChange={this._onChangeCheck(o.name)}
                        value={o._id}
                        color="primary"
                      />
                    }
                  />
                ))}
              </FormGroup>
            </FormControl>
          </div>
          <Divider />
        </div>
      </Collapse>
    );
  }

  renderUniversities(classes) {
    const { texts } = this.state;
    return (
      <div className={classes.messageContainer}>
        <Typography variant="subheading">
          {texts.header.target_institution}
        </Typography>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup row>
            {this.props.universities.map(u => (
              <FormControlLabel
                key={u._id}
                label={u.name}
                control={
                  <Checkbox
                    checked={this.state[u.name]}
                    onChange={this._onChangeCheck(u.name)}
                    value={u._id}
                    color="primary"
                  />
                }
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>
    );
  }

  renderDeliveryDate(classes, delivery) {
    return (
      <React.Fragment>
        <Typography
          variant="subheading"
          className={classNames(classes.title, classes.secondTitle)}
        >
          Delivery Date
        </Typography>
        <div className={classes.deliveryForm}>
          <FormControl className={classes.formControl}>
            <Select
              value={delivery}
              onChange={this._handleDelivery}
              name="delivery"
            >
              <MenuItem value="now">Send Now</MenuItem>
              <MenuItem value="later">Send Later</MenuItem>
            </Select>
          </FormControl>
          {delivery === 'later' && (
            <form noValidate>
              <TextField
                id="datetime-local"
                label="Date and Time"
                type="datetime-local"
                defaultValue="2017-05-24T10:30"
                InputLabelProps={{ shrink: true }}
              />
            </form>
          )}
        </div>
      </React.Fragment>
    );
  }

  renderButton(classes, delivery) {
    const { titleEn, titleFr, bodyEn, bodyFr, tutors, students, dontTranslate, texts } = this.state;
    let missingInput = titleEn === '' || bodyEn === '';
    if (!dontTranslate)
      missingInput = missingInput || titleFr === '' || bodyFr === '';

    let orgFilled = false;
    let uniFilled = false;
    if (tutors) {
      // check if at least one organization is checked
      this.props.organizations.forEach(o => {
        if (this.state[o.name])
          orgFilled = true;
      });
    }
    this.props.universities.forEach(u => {
      if (this.state[u.name])
        uniFilled = true;
    });
    const missing = missingInput || ((tutors && !orgFilled) || (!students && !tutors)) || !uniFilled;
    if (delivery === 'now') {
      return (
        <Button
          disabled={missing}
          color="primary"
          variant="raised"
          className={classes.button}
          onClick={this._onClickSend}
        >
          {texts.button_text.send}
          <Send className={classes.sendIcon} />
        </Button>
      );
    }
    return (
      <Button disabled={missing} color="primary" variant="raised" className={classes.button}>
        <Alarm className={classes.alarmIcon} />
        {texts.button_text.schedule}
      </Button>
    );
  }

  render() {
    const { classes } = this.props;
    const { value, delivery } = this.state;

    return (
      <Paper>
        {this.renderTitle(classes)}
        <Divider />
        {this.renderMessage(classes)}
        <Divider />
        {this.renderTarget(classes)}
        <Divider />
        {this.renderOrganizations(classes)}
        <Divider />
        {this.renderUniversities(classes)}
        <Divider />
        {false && this.renderDeliveryDate(classes, delivery)}
        <div className={classes.buttonContainer}>
          {this.renderButton(classes, delivery)}
        </div>
      </Paper>
    );
  }
}

AnnouncementCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  organizations: _.get(state, 'auth.data.user.organizations') || [],
  universities: _.get(state, 'auth.data.user.universities') || [],
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  sendAnnouncement: params => dispatch(sendAnnouncement(params)()),
  fetchAnnouncements: params => dispatch(fetchAnnouncements(params)()),
});

export default compose(
  withStyles(styles, { name: 'AnnouncementCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AnnouncementCard);



// WEBPACK FOOTER //
// ./src/modules/announcement/cards/AnnouncementCard/index.js